import type { HealthMetricType } from '../../fetchHooks/useHealthmetrictypesWithMeasurements';
import { MydayStatsGraph } from './MydayStatsGraph';

type HealthMetricGraphsProps = {
  selectedGraphs?: HealthMetricType[];
  // measurementList?: number[] | undefined;
  showBloodworkDescription?: boolean;
};

const HealthMetricGraphs = ({ selectedGraphs, showBloodworkDescription }: HealthMetricGraphsProps) => {
  // const { data: healthmetrictypes, isLoading } = useHealthmetrictypesWithMeasurements();
  // if (isLoading) return <p>Loading...</p>;
  if (selectedGraphs?.length) {
    return (
      <div className="myday-graphs-wrapper">
        {selectedGraphs?.map((healthMetric) => {
          return (
            <MydayStatsGraph
              healthMetric={healthMetric}
              key={healthMetric.id}
              showBloodworkDescription={showBloodworkDescription}
            />
          );
        })}
      </div>
    );
  }
  if (!selectedGraphs || selectedGraphs.length === 0) return <></>;

  // return (
  //   <div className="myday-graphs-wrapper">
  //     {selectedGraphs.length === healthmetrictypes?.length ? (
  //       healthmetrictypes?.map((item) => (
  //         <MydayStatsGraph showBloodworkDescription={showBloodworkDescription} healthMetric={item} key={item.id} />
  //       ))
  //     ) : (
  //       <MydayStatsGraph
  //         showBloodworkDescription={showBloodworkDescription}
  //         healthMetric={healthmetrictypes?.find((healthMetric) => healthMetric.id === selectedGraph)}
  //       />
  //     )}
  //   </div>
  // );
};
export default HealthMetricGraphs;
